module.exports = __webpack_public_path__ + "img/security-audit-img-5.9caef0f9.webp";